<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>1号AI > <b>数字人管理</b></BreadcrumbItem>
      </Breadcrumb>
	  <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
		  <span class="search_span_width">
		    <span class="search_span_width_part1">人物ID：</span>
		  				 <Input v-model="search.figure_id" clearable style="width: 80px" />
		  	</span>
	       <span class="search_span_width">
	         <span class="search_span_width_part1">数字人名称：</span>
	       				 <Input v-model="search.name" style="width: 130px" clearable/>
	       	</span>
<!--	       <span class="search_span_width">
	         <span class="search_span_width_part1">渠道：</span>
				<Select v-model="search.channel" clearable style="width:150px">
					<Option v-for="item in channel_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
				</Select>
	       	</span>-->
	         <span class="search_span_width">
             <span class="search_span_width_part1">上架状态：</span>
              <Select v-model="search.status" clearable  style="width:130px">
                   <Option :value='-2'>未上架</Option>
                   <Option :value='-1'>待上架</Option>
                   <Option :value='1'>已上架</Option>
                   <Option :value='2'>已下架</Option>
              </Select>
	         </span>
	         <span class="search_span_width">
	             <span class="search_span_width_part1">上架位置：</span>
					<Select v-model="search.fit_type" clearable  style="width:130px">
						   <Option :value='1'>视频共享</Option>
						   <Option :value='2'>直播共享</Option>
						   <Option :value='3'>客户独享</Option>
						   <Option :value='4'>数字人商城</Option>
					</Select>
	         </span>
	    <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getFigureList(1)">搜索</Button>
	  </Card>
      <Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="figure_list"></Table>
		   <Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getFigureList"/>
        </Card>
      </Card>
    </Content>
   <Modal v-model="showmodal" :footer-hide=true title="AI大脑">
        <Form ref="figure" :model="figure" :label-width="80" >
          <FormItem label="名称" prop="title">
             <Input v-model="figure.title"  :disabled='true'/>
          </FormItem>
          <FormItem label="基础模型" prop="title">
	  				 <Select v-model="figure.gpt_model" style="width:260px">
	  				        <Option value="3" :key="3">文心一言大模型</Option>
	  						<Option value="2" :key="2">风平保险大模型（基于GPT4微调）</Option>
	  				</Select>
          </FormItem>
<!--          <FormItem label="人物设定" prop="persona">
            <Input v-model="figure.persona"  type="textarea" />
          </FormItem>-->
          <FormItem label="人设特定调优" prop="prompt">
            <Input v-model="figure.prompt"  type="textarea" />
          </FormItem>
          <FormItem label="话题标签" prop="topic_label">
            <Input v-model="figure.topic_label"  type="textarea" />
            <div style ="color: red">","英文逗号分割</div>
          </FormItem>
          <FormItem label="学习文档" prop="study_url">
            <Upload :action="getUploaFiledUrl" :data="figure" :headers="uploadHeader" :on-success="successStudy">
              <Button icon="ios-cloud-upload-outline">上传学习文档</Button>
            </Upload>
            <span style ="color: red">支持.docx,.txt</span>
          </FormItem>
          <FormItem>
              <Button type="primary" @click="updateAiFigureRole()">提交</Button>
          </FormItem>
        </Form>
    </Modal>
    <Modal v-model="showinfomodal" :footer-hide=true title="基础信息">
      <Form ref="figure" :model="figure" :label-width="80" >
        <FormItem label="数字人ID" prop="id">
          <Input v-model="figure.id"  disabled/>
        </FormItem>
        <FormItem label="名称" prop="title">
          <Input v-model="figure.title"  />
        </FormItem>
        <FormItem label="头像" prop="cover">
          <img :src="figure.cover" :style="{'width':'100px'}"/>
          <Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successCover">
            <Button icon="ios-cloud-upload-outline">上传头像</Button>
          </Upload>
        </FormItem>
        <FormItem label="性别" prop="sex">
          <RadioGroup v-model="figure.sex">
            <Radio label="男"></Radio>
            <Radio label="女"></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="主页标签" prop="user_label">
          <Input v-model="figure.user_label"  type="textarea" />
          <div style ="color: red">","英文逗号分割</div>
        </FormItem>
        <FormItem label="聊过的人数" prop="talker_num">
          <InputNumber :min="0" v-model="figure.talker_num" size="large" controls-outside/><span>真实人数：{{figure.user_num}}</span>
        </FormItem>
        <FormItem label="简介" prop="introduction">
          <Input v-model="figure.introduction" type="textarea"  />
        </FormItem>
        <FormItem label="创建人简称" prop="create_user_introduction">
          <Input v-model="figure.create_user_introduction" type="textarea"  />
        </FormItem>
<!--        <FormItem label="主页视频" prop="home_video">
          <video ref="audio" controls="controls" :src="figure.home_video" width='30%'></video>
          <Upload :action="getUploadUrl" :data="figure" :headers="uploadHeader" :on-success="successUpload">
            <Button icon="ios-cloud-upload-outline">上传视频</Button>
          </Upload>
        </FormItem>-->
        <FormItem label="主页视频" prop="home_video">
          <video ref="webm" controls="controls" preload="metadata" :src="figure.home_video" v-show="figure.home_video" width='40%' height="40%"></video>
          <a :href="figure.home_video" v-show="figure.home_video">主页视频下载</a>
          <Upload	:before-upload="handleUploadHomeVideo"	action="//jsonplaceholder.typicode.com/posts/">
            <Button icon="ios-cloud-upload-outline">上传视频件</Button>
          </Upload>
          <Progress :percent="upLoadProgress_home_video" v-show="upLoadProgress_show_home_video" />
          <div v-if="file_home_video !== null">Upload file: {{ file_home_video.name }} <Button type="text" @click="doUploadHomeVideo" :loading="loadingStatus_home_video">{{ loadingStatus_home_video ? '上传中...' : '点击上传' }}</Button></div>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="updateFigureRole()">提交</Button>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="studyfiguremodal" :footer-hide=true title="学习内容" :width="70">
      <Table :columns="study_figure_list" :data="study_figure_data"></Table>
    </Modal>
  </Layout>
</template>
<script>
import OSS from 'ali-oss';

export default {
  data(){
    return {
		search : {
			figure_id:'',
			channel:'',
			fit_type:0,
			status:0
		},
		loading2: false,
		showmodal:false,
    showinfomodal:false,
    studyfiguremodal:false,
		showshelfmodal:false,
		showtrainmodal:false,
    file_home_video:null,
    loadingStatus_home_video:false,
    upLoadProgress_home_video:0,
    upLoadProgress_show_home_video:false,
    study:{
      figure_id:0,
      id:0
    },
		recordTotal:0,
		page:1,
		figure_list:[],
		user_list:[],
		channel_list:[],
    study_figure_data:[],
		train:{
			id:0,
			video:'',
			train_video:'',
			figure_id:0,
			train_name:'',
			authorization_file:'',
			webm:''
		},
		figure:{
			id:0,
			title:'',
      create_name:"",
      user_label:'',
      introduction:'',
      create_user_introduction:'',
      topic_label:'',
      persona:'',
      prompt:'',
      gpt_model:0,
      cover:"",
      study_url:"",
      home_video:"",
      sex:"女",
      talker_num:0,
      user_num:0,
      is_role:1
		},

		fit_type_user:false,
		shelfs:{
			id:0,
			channel:[],
			sex:'女',
			fit_type:[],
			user_id:[],
			seq:0
		},
    study_figure_list:[
      { title: '学习ID', key: 'id', align: 'center' },
      { title: '学习名称', key: 'study_name', align: 'center' },
      { title: '学习内容', key: 'study_content', align: 'center',
        render:(h,params) =>{
          return h('Input', {
            height:"100px",
            props: { value: params.row.study_content , type: 'textarea',style:{height:100}},
           // key:params.row.study_content,//"study_content",
            style : { width: '200px', height : '110px' ,textAlign: 'center'}
          })
        }},
      { title: '学习状态', key: 'job_status_name', align: 'center' },
/*      { title: '操作', key: 'action', align: 'center',width: 200,
        render: (h, params) => {
          let btns=[]
          btns.push(
              h('Button', {
                props: { type: 'warning', size: 'small' },
                style: { marginRight: '5px', marginBottom: '5px'},
                on: {
                  click: () => {
                    this.delStudyFigure(params.row.id);
                  }
                }
              }, '删除'),
          );
          return h("div",btns);
        }
      }*/
    ],
		tableColumns:[
		{ title: '数字人ID', key: 'id', align: 'center' },
		{ title: '名称', key: 'title', align: 'center' },
		{ title: '头像', key: 'cover', align: 'center',
		render:(h,params) =>{
		   return h('img',{
			 attrs : {src : params.row.cover},
			 style : { width : '80px', height : '80px' }
		   })
		}},
    { title: '人物设定', key: 'persona', align: 'center' },
		{ title: '创建人', key: 'create_name', align: 'center' },
		{ title: '标签', key: 'user_label', align: 'center' },
    { title: '学习记录', key: 'name', align: 'center',
      render: (h, params) => {
        let btns=[]
        var txt = '查看学习内容';
        btns.push(
            h('Button', {
              props: { type: 'dashed',},
              on: {
                click: () => {
                  this.getstudyfigureList(params.row.id);
                  this.studyfiguremodal  = true;
                }
              }
            }, txt),
        );
        return h("div",btns);
      }
    },
		{ title: '操作', key: 'action', align: 'center',width: 200,
		  render: (h, params) => {
			let btns=[]
			btns.push(
          h('Button', {
            props: { type: 'warning', size: 'small' },
            style: { marginRight: '5px', marginBottom: '5px'},
            on: {
              click: () => {
                this.figure.id = params.row.id;
                this.figure.title = params.row.title;
                this.figure.cover = params.row.cover;
                this.figure.sex = params.row.sex;
                this.figure.user_label =params.row.user_label;
                this.figure.talker_num =parseInt(params.row.talker_num);
                this.figure.introduction =params.row.introduction;
                this.figure.create_user_introduction =params.row.create_user_introduction;
                this.figure.home_video =params.row.home_video;
                this.figure.user_num =params.row.user_num;
                this.showinfomodal = true;
              }
            }
          }, '基础信息'),
				h('Button', {
				  props: { type: 'warning', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {
						this.figure.id = params.row.id;
						this.figure.title = params.row.title;
						this.figure.prompt = params.row.prompt;
						this.figure.gpt_model =params.row.gpt_model;
						this.figure.topic_label =params.row.topic_label;
						this.figure.study_url ="";
						this.showmodal = true;
					}
				  }
				}, 'AI大脑'),
			);
			return h("div",btns);
		  }
		}
		],
		uploadHeader:{
		  "Authorization":localStorage.getItem('token')
		},
	}
  },
  mounted:function(){
	this.getFigureList();
  },
  computed:{
	  getUploadUrl(){
	      return process.env.VUE_APP_APIHOST+'/admin/figure/upload';
	  },
    getUploaFiledUrl(){
      return process.env.VUE_APP_APIHOST+'/admin/miniAi/upload';
    },

  },
  methods:{
    changeFitType(e){
      //console.log(e);
      if (e.indexOf(3) != -1) {
        this.fit_type_user = true;
      } else {
        this.fit_type_user = false;
      }
    },
    handleUploadHomeVideo (file) {
      this.file_home_video = file;
      return false;
    },
    getChannel() {
      this.http.get('/admin/common/settingKey',{params:{'key':'app_channel'}}).then(response=>{
        let data=response.data;
        console.log(data);
        if(data.code!==0){
        alert(data.message);
        } else{
        this.channel_list = data.data;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    getFigureList(page=this.page) {
      this.page = page;
      let p = {'page' : page}
      let params = Object.assign(this.search, p);
      this.http.get('/admin/miniAi/figureStudyList',{params:params}).then(response=>{
        let data=response.data;
        if(data.code!==0){
        alert(data.message);
        } else{
        this.figure_list = data.data.list;
        this.recordTotal = data.data.total;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    updateFigureRole(){
      this.$Modal.confirm({
        content: '<p>确定提交？</p>',
        onOk: () => {
          this.http.post('/admin/miniAi/updateFigureRole',{
            id:this.figure.id,
            title:this.figure.title,
            cover:this.figure.cover,
            sex:this.figure.sex,
            user_label:this.figure.user_label,
            talker_num:this.figure.talker_num,
            create_user_introduction:this.figure.create_user_introduction,
            home_video:this.figure.home_video,

          }
        ).then(response=>{
            let data=response.data;
            if(data.code!==0) {
              this.$Message.error(data.message);
              return false;
            }else{
              this.$Message.info(data.message);
              this.showmodal = false;
              this.showinfomodal =false;
              this.figure.study_url="";
              this.getFigureList(this.page);
              return true;
            }
          });
        }
      });

    },
    updateAiFigureRole(){
      this.$Modal.confirm({
        content: '<p>确定提交？</p>',
        onOk: () => {
          this.http.post('/admin/miniAi/updateFigureRole', {
            id:this.figure.id,
            study_url:this.figure.study_url,
            title:this.figure.title,
            gpt_model:this.figure.gpt_model,
            prompt:this.figure.prompt,
            topic_label:this.figure.topic_label
           }
          ).then(response=>{
            let data=response.data;
            if(data.code!==0) {
              this.$Message.error(data.message);
              return false;
            }else{
              this.$Message.info(data.message);
              this.showmodal = false;
              this.showinfomodal = false;
              this.figure.study_url = "";
              this.getFigureList(this.page);
              return true;
            }
          });
        }
      });

    },
    userlist(query){
      if (query !== '' && query.length==11) {
        this.loading2 = true;
        setTimeout(() => {
          this.loading2 = false;

          this.http.get('/admin/user/userList',{params:{mobile:query}}).then(response=>{
            let data=response.data;
            if(data.code!==0)
            {
            alert(data.message);
            } else{
            this.user_list = data.data.list;
            }
          }).catch(()=>{
            this.$Message.error('网络错误');
          });

        }, 200);
      }
    },
    getstudyfigureList(figure_id){//定制用户列表
      this.study.figure_id = figure_id;
      this.http.get('/admin/miniAi/getstudyfigureList',{params:{figure_id:figure_id}}).then(response=>{
        let data=response.data;
        if(data.code!==0) {
          this.$Message.error(data.message);
        } else{

         // const objToStr = JSON.stringify(data.data.list)
          this.study_figure_data = data.data.list;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    delStudyFigure(id){//删除学习内容
      alert(id);
      this.http.post('/admin/miniAi/delStudyFigure',{figure_id:this.study.id}).then(response=>{
        let data=response.data;
        if(data.code!==0) {
          this.$Message.error(data.message);
        } else{
          this.getstudyfigureList(this.study.figure_id);
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    doUploadHomeVideo() {
      this.http.get('/upload/getUpoadVideoToken?bucket=ipbuilder-private').then(response=>{
        let data=response.data;
        if(data.StatusCode!=200){
          this.$Message.error(data.message);
        } else {
          const config = data;
          const ossClient = new OSS({accessKeyId: config.AccessKeyId,accessKeySecret: config.AccessKeySecret,
            stsToken: config.SecurityToken,bucket:config.bucket,region:config.RegionId,
            secure:true,endpoint:'oss-cn-zhangjiakou.aliyuncs.com'
          });
          let myDate = new Date((new Date).getTime() + 8*60*60*1000);
          let time = myDate.toJSON().split('T').join('').substr(0,12).replaceAll('-', '').toString();
          let lastIndex = this.file_home_video.name.lastIndexOf('.');
          let ext = this.file_home_video.name.substring(lastIndex+1);
          const fileName = this.figure.id+'-'+time+Math.round(Math.random()*10).toString()+'.'+ext;

          const progress = (p, _checkpoint) => {
            this.loadingStatus_home_video = true;
            this.upLoadProgress_home_video = parseInt(p*100);
          };

          ossClient.multipartUpload('freefishpc/figure/home_video/'+this.figure.id+"/"+fileName, this.file_home_video,{progress}).then(
              result => {
                this.file_home_video = null;
                var url = result.res.requestUrls[0];
                var index = url.indexOf("?");
                this.figure.home_video = url.substr(0, index);
                console.log(this.figure.home_video);
                console.log(`Common upload ${fileName} succeeded, result === `, result)
              }).catch(
              err => {
                console.log(`Common upload ${fileName} failed === `, err);
              });
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    successStudy(response, file, fileList){
      let data=response
      if(data.code!=0) {
        this.$Message.error(data.message);
        return true;
      }
      this.figure.study_url = data.data.url;
      //alert(this.figure.study_url);
      this.$Message.success('上传成功');
    },
    successCover(response, file, fileList){
      let data=response
      if(data.code!=0) {
        this.$Message.error(data.message);
        return true;
      }
      this.figure.cover = data.data.url;
      this.$Message.success('上传成功');
    },
    successUpload(response, file, fileList){
      let data=response
      if(data.code!=0) {
        this.$Message.error(data.message);
        return true;
      }
      //alert(data.data.url);
      this.figure.video = data.data.url;
      this.$Message.success('上传成功');
    },
  }

}
</script>
<style>
textarea.ivu-input{
  height: 100px;
}

</style>